export default {
  buttons: {
    confirm: 'Confirm',
  },
};
